import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {  useHistory, useParams } from 'react-router';
import { searchProject } from './../../helpers/searchProject';

const ProjectScreen = () => {
    const {projects} = useSelector(state => state.project)
    let {projectId}= useParams();
    let history = useHistory();
    useEffect(() => {
        if (projects.length===0) {
            history.push('/portafolio')
        }
    }, [projects,history])
    const project=searchProject(projectId,projects)
    return (
        <div>
            <h2 className="project__title">{project?.title}</h2>
            <div className="img__container">
                <img src={project?.img} className="img__w" alt="" />
                
            </div>
            <div className="img__container">
                <div className="project__descr" dangerouslySetInnerHTML={{__html: project?.description}}>
            
                </div>
            </div>
        </div>
    );
}

export default ProjectScreen;
